<template>
  <Html data-theme="light" />
  <KernelApp>
    <KernelContainer screen>
      <MaisErrorState
        root
        :error
        :clear-error="clearError"
      />
    </KernelContainer>
  </KernelApp>
</template>

<script lang="ts" setup>
const props = defineProps<{
  error: Error
}>()

console.debug(props.error)
</script>

<style scoped>
.container {
  align-content: center;
}
</style>
